/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_Date_ToInputs */

const vi_my_weighings_date_to = /** @type {(inputs: My_Weighings_Date_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến ngày`)
};

/**

* @param {My_Weighings_Date_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_date_to = /** @type {((inputs?: My_Weighings_Date_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_Date_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_date_to(inputs)
});